import React, { useContext, ReactNode } from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';

import SubNavigation from 'components/SubNavigation/SubNavigation';
import PerformanceSummary from '../Overview/PerformanceSummary';
import View from '../Overview/View';
import Concerts from 'pages/Entity/Track/Shared/Concerts';

import { overviewSubTopics } from 'topics';
import { IEntityPageComponentProps } from 'pages/Entity/shared';
import { EntityContext } from 'context/entityContext';
import TopicFilters from 'components/TopicFilters/TopicFilters';

const Overview: React.FC<IEntityPageComponentProps> = (props) => {
  const { match, pathPrefix, artistMetadata } = props;
  const { entityId, parentEntityId } = match.params;

  const { compareMode, topic } = useContext(EntityContext);

  return (
    <>
      <SubNavigation topic="overview" variants={overviewSubTopics} />
      <TopicFilters topic={topic[1] || topic[0]} compareMode={compareMode} />
      <Switch>
        <Route
          exact
          path={`${pathPrefix}/release/${parentEntityId}/version/${entityId}/overview/summary`}
          render={(): ReactNode => <PerformanceSummary />}
        />
        <Route
          exact
          path={`${pathPrefix}/release/${parentEntityId}/version/${entityId}/overview/view`}
          render={(): ReactNode => <View />}
        />
        <Redirect
          exact
          from={`${pathPrefix}/release/${parentEntityId}/version/${entityId}/certifications`}
          to={`${pathPrefix}/release/${parentEntityId}/version/${entityId}/overview/summary`}
        />
        <Route
          exact
          path={`${pathPrefix}/release/${parentEntityId}/version/${entityId}/overview/concerts`}
          render={(): any => (
            <Concerts
              topic={topic.join('/')}
              artist={{
                entityType: artistMetadata?.type,
                entityId: artistMetadata?.id,
                name: artistMetadata?.displayName,
              }}
              compareMode={compareMode}
            />
          )}
        />
      </Switch>
    </>
  );
};

export default Overview;
